import { Outlet, useLocation } from "react-router-dom";
import MainHeader from "./MainHeader";
import MainFooter from "./MainFooter";
import ScrollToTop from "./ScrollToTop";
import { useEffect } from "react";
import WaChat from "./WaChat";

const MainLayout = () => {
    const { pathname } = useLocation();
    const isInterviewRoute = pathname.startsWith('/interview/');
    const isInterviewFullscreenRoute = pathname.startsWith('/interview/session/');

    useEffect(() => {
        window.scrollTo({
            top: 0
        })
    }, [pathname])

    return (
        <div className={`main-layout-container ${isInterviewFullscreenRoute ? 'main-layout-container--interview' : ''}`}>
            {!isInterviewRoute && <MainHeader />}
            <div className={`outlet-wrapper ${isInterviewRoute ? 'outlet-wrapper--interview' : ''} ${isInterviewFullscreenRoute ? 'outlet-wrapper--interview-fullscreen' : ''}`}>
                <Outlet />
            </div>
            {!isInterviewRoute && <MainFooter />}
            {/* <ScrollToTop/> */}
            {!isInterviewRoute && <WaChat />}
        </div>
    );
};

export default MainLayout;
